
import './index.less'
import React from 'react'
const te = ['left', 'center', 'right']
console.log(React)
export default function BasicsText(props) {
  return (<div className={`BasicsText ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>
    <p style={{
      paddingTop: props.ifon.padding_top + 'px',
      paddingBottom: props.ifon.padding_bottom + 'px',
      justifyContent: te[props.ifon.text_alignment],
      fontSize: props.ifon.font_size + 'px',
      color: props.ifon.font_color,
      fontWeight: props.ifon.font_style ? 'bold' : 'normal'
    }} className='BasicsText_text' placeholder='请在右侧输入文本内容' disabled>{props.ifon.text ? props.ifon.text : '请输入内容'}</p>
  </div>)
}
